import React, { useState, useEffect } from 'react'
import {Link,useHistory} from "react-router-dom"
import './Chat.css'
import Moment from 'moment'
import firebase from 'firebase'
import { Button} from '@material-ui/core'
import { NavBar } from '../navBar'

export const RoomList =() => {
    const [room, setRoom] = useState([])
    const [nickname, setNickname] = useState('')
    const history = useHistory()

    useEffect(() => {
        const fetchData = async () => {
            setNickname(localStorage.getItem('nickname'))
            firebase.database().ref('rooms/').on('value', resp => {
                setRoom([])
                setRoom(snapshotToArray(resp))
            })
        }
        fetchData()
    }, [])

    const snapshotToArray = (snapshot) => {
        const returnArr = []
        snapshot.forEach((childSnapshot) => {
            const item = childSnapshot.val()
            item.key = childSnapshot.key
            returnArr.push(item)
        })
        return returnArr
    }

    const enterChatRoom = (roomname) => {
        const chat = { roomname: '', nickname: '', message: '', date: '', type: '' }
        chat.roomname = roomname
        chat.nickname = nickname
        chat.date = Moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
        chat.message = `${nickname} enter the room`
        chat.type = 'join'
        const newMessage = firebase.database().ref('chats/').push()
        newMessage.set(chat)

        firebase.database().ref('roomusers/').orderByChild('roomname').equalTo(roomname).on('value', (resp) => {
            let roomuser = []
            roomuser = snapshotToArray(resp)
            const user = roomuser.find(x => x.nickname === nickname)
            if (user !== undefined) {
              const userRef = firebase.database().ref('roomusers/' + user.key)
              userRef.update({status: 'online'})
            } else {
              const newroomuser = { roomname: '', nickname: '' }
              newroomuser.roomname = roomname
              newroomuser.nickname = nickname
              const newRoomUser = firebase.database().ref('roomusers/').push()
              newRoomUser.set(newroomuser)
            }
        })
    
        history.push('/chatroom/' + roomname)
    }

    return (
        <>
        <NavBar />
        <div className = 'chatroom__list__container'>
            <div className = 'room__info__container'>
                <h2 id = 'chat__list__title'>Room List</h2>
                <div id = 'add__room__link'>
                    <Button>
                    <Link to="/addroom">Add Room</Link>
                    </Button>
                    <Button id = 'back__to__chat__login'>
                        <Link to = '/chat'>Go Back</Link>
                </Button>
                </div>
                <ul >
                    {room.map((item, idx) => (
                        <li className = 'chatroom__list'key={idx} action onClick={() => { enterChatRoom(item.roomname) }}>{item.roomname}</li>
                    ))}
                </ul>
                </div>
        </div>
        </>
    )

}
